module.exports = __webpack_public_path__ + "img/icon_ListRechargeStores.335dd783.png";